export default "__VITE_ASSET__2e500399__"